import { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, ChevronDown, Layers } from 'lucide-react'
import './Navbar.css'

const products = [
  { label: 'Human Capital Management', path: '/products/human-capital-management' },
  { label: 'Takeaway System', path: '/products/takeaway-system' },
  { label: 'Account Management', path: '/products/account-management' },
  { label: 'Textile ERP', path: '/products/textile-erp' },
  { label: 'Manufacturing Inventory', path: '/products/manufacturing-inventory' },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const [dropOpen, setDropOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const dropRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    setOpen(false)
    setDropOpen(false)
  }, [location])

  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link to="/" className="navbar__logo">
          <Layers size={22} />
          <span>Nexacore</span>
          <sup>solutions</sup>
        </Link>

        <ul className="navbar__links">
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
          <li className="navbar__dropdown" ref={dropRef}>
            <button onClick={() => setDropOpen(!dropOpen)} className={dropOpen ? 'active' : ''}>
              Products <ChevronDown size={15} className={dropOpen ? 'rot' : ''} />
            </button>
            {dropOpen && (
              <div className="navbar__dropdown-menu">
                {products.map(p => (
                  <Link key={p.path} to={p.path} className={location.pathname === p.path ? 'active' : ''}>{p.label}</Link>
                ))}
              </div>
            )}
          </li>
          <li><Link to="/blogs" className={location.pathname === '/blogs' ? 'active' : ''}>Blogs</Link></li>
          <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact Us</Link></li>
        </ul>

        <Link to="/contact" className="btn-primary navbar__cta">Get a Demo</Link>

        <button className="navbar__hamburger" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="navbar__mobile">
          <Link to="/">Home</Link>
          <div className="navbar__mobile-group">
            <span>Products</span>
            {products.map(p => (
              <Link key={p.path} to={p.path} className="navbar__mobile-sub">{p.label}</Link>
            ))}
          </div>
          <Link to="/blogs">Blogs</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/contact" className="btn-primary" style={{marginTop:'8px'}}>Get a Demo</Link>
        </div>
      )}
    </nav>
  )
}
